import React from "react";
import styles from "./price-range.css";

export interface PriceRangeProps {
    minMaxSame: boolean;
    hasRegularPrice: boolean;
    multipleStores: boolean;
    regularPriceWithCurrencySymbol: string;
    minimumPriceWithCurrencySymbol: string;
    maximumPriceWithCurrencySymbol: string;
}

function PriceRange({
    minMaxSame,
    hasRegularPrice,
    multipleStores,
    regularPriceWithCurrencySymbol,
    minimumPriceWithCurrencySymbol,
    maximumPriceWithCurrencySymbol,
}: PriceRangeProps): React.ReactElement {
    function renderSinglePrice(): React.ReactElement {
        return (
            <>
                {"From "}
                {hasRegularPrice && (
                    <span>
                        <del>{regularPriceWithCurrencySymbol}</del>{" "}
                    </span>
                )}
                <span className={hasRegularPrice ? styles.priceSale : ""}>
                    {minimumPriceWithCurrencySymbol}
                </span>
            </>
        );
    }

    function renderFromToRange(): React.ReactElement {
        return (
            <>
                <span>{minimumPriceWithCurrencySymbol}</span>
                {" - "}
                <span>{maximumPriceWithCurrencySymbol}</span>
                {multipleStores && (
                    <span className={styles.multipleStores}>
                        {" (From multiple stores)"}
                        {/* todo I18N-291 */}
                    </span>
                )}
            </>
        );
    }

    return (
        <div className={styles.priceRange}>
            {minMaxSame ? renderSinglePrice() : renderFromToRange()}
        </div>
    );
}

export default PriceRange;
